/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Icon } from "@insticator/insticator-ui";
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/labelassignmentcollection/labelassignmentitem/labelassignmentitem_styles';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT COLLECTION ITEM  : DROPDOWN ITEM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {


    return (
        <li className={`labelassignmentitem ${props.classes.labelassignmentitem}`}>
            <span className={`itemtext`}>{props.labelName}</span>
            <span className={`itemicon`} onClick={() => props.removeLabel(props.labelUUID)}>
                <Icon name={'times-circle'}/>
            </span>
        </li>
    );
});
